import { SerializableObject } from './serializable-object';


export class MobizEndpoint extends SerializableObject {
  public id: string;
  public createdUtc: Date;
  public modifiedUtc: Date;
  public createdBy: string;
  public modifiedBy: string;
  public name: string;
  public erpDriver: string;
  public erpUrl: string;
  public adminDomainId: string;
}
